// @flow

export const gtHaptikMedium = "'GT Haptik Medium', sans-serif"
export const gtHaptikMediumRotalic = "'GT Haptik Medium Rotalic', sans-serif"
export const inter = "'Inter', sans-serif"

export const bolder = 700
